module.exports = __webpack_public_path__ + "media/packs/images/location-marker-2de6e0450365a28421ffc0208cc7a3ad.svg";